var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDelete24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_delete_24px",
    "data-name": "icon/delete_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M14.75,10.25v7.5h-1.5v-7.5Z",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M10.75,17.75v-7.5H9.25v7.5Z",
    fill: "#3bb0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M16.75,2.25H7.25v4H3v1.5H5.25v14h13.5v-14H21V6.25H16.75Zm-1.5,4V3.75H8.75v2.5Zm-8.5,1.5v12.5h10.5V7.75Z",
    fill: "#3bb0ff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete24Px);
export default __webpack_public_path__ + "static/media/icon-delete_24px.94ca1cb5e64c6c91ab54254a68840f1a.svg";
export { ForwardRef as ReactComponent };